<template lang="html">
  <div class="custom-toggle row">
		<div class="toggle-part left" :class="{active: isActive(list[0])}" @click="setToggle(list[0])">
			{{ list[0] }}
		</div>
		<div class="toggle-part right" :class="{active: isActive(list[1])}" @click="setToggle(list[1])">
			{{ list[1] }}
		</div>
  </div>
</template>

<script>
export default {
	name: 'custom-toggle',
	props: ['value', 'values'],
	data () {
		return {
			toggle: false,
			list: ['Oui', 'Non'],
			bool: true
		}
	},
	mounted () {
		this.toggle = this.value
		this.list = this.values || this.list
		this.bool = (this.list !== this.values)
		if (this.bool) { this.toggle = (this.toggle) ? 'Oui' : 'Non' }
	},
	methods: {
		setToggle (value) {
			if (this.bool) {
				this.$emit('change', (value === 'Oui'))
				this.$emit('input', (value === 'Oui'))
			} else {
				this.$emit('change', value)
				this.$emit('input', value)
			}
			this.toggle = value
		},
		isActive (value) {
			return (this.toggle === value)
		}
	},
	watch: {
		value (foo) {
			this.toggle = foo
			if (this.bool) { this.toggle = (this.toggle) ? 'Oui' : 'Non' }
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/common/components/Form/CustomToggle.vue